import React, { useState } from "react";
import { FlightOffer } from "../../types/flight";
import FlightOfferRow from "./FlightOfferRow";

interface FlightOfferGroupProps {
    flights: FlightOffer[];
    onSelectFlight: (
        flight: FlightOffer,
        fareType: "economy" | "premium" | "business"
    ) => void;
}

const FlightOfferGroup: React.FC<FlightOfferGroupProps> = ({
    flights,
    onSelectFlight,
}) => {
    const [selectedFlightId, setSelectedFlightId] = useState<string | null>(
        null
    );
    const [selectedFareType, setSelectedFareType] = useState<
        "economy" | "premium" | "business" | null
    >(null);
    const [displayCount, setDisplayCount] = useState(3);

    const handleSelectFare = (
        flight: FlightOffer,
        fareType: "economy" | "premium" | "business"
    ) => {
        setSelectedFlightId(flight.id);
        setSelectedFareType(fareType);
        onSelectFlight(flight, fareType);
    };

    const handleShowMore = () => {
        setDisplayCount((prev) => Math.min(prev + 3, flights.length));
    };

    const visibleFlights = flights.slice(0, displayCount);
    const hasMoreFlights = displayCount < flights.length;

    return (
        <div className="max-w-[1200px] mx-auto">
            {/* Flight rows as individual cards */}
            <div className="space-y-2">
                {visibleFlights.map((flight) => (
                    <FlightOfferRow
                        key={flight.id}
                        flight={flight}
                        isSelected={selectedFlightId === flight.id}
                        selectedFareType={
                            selectedFlightId === flight.id
                                ? selectedFareType || undefined
                                : undefined
                        }
                        onSelect={(flight, fareType) =>
                            handleSelectFare(
                                flight,
                                fareType as "economy" | "premium" | "business"
                            )
                        }
                    />
                ))}
            </div>

            {/* See more button - bottom right */}
            {hasMoreFlights && (
                <div className="flex justify-end mt-6 mb-6 gap-4">
                    <button
                        onClick={handleShowMore}
                        className="px-8 py-3 border border-[#0047ba] text-[#0047ba] rounded-lg text-base font-medium hover:bg-[#0047ba] hover:text-white transition-colors"
                    >
                        Back
                    </button>
                    <button
                        onClick={handleShowMore}
                        className="px-8 py-3 border border-[#0047ba] text-[#0047ba] rounded-lg text-base font-medium hover:bg-[#0047ba] hover:text-white transition-colors"
                    >
                        See more flights
                    </button>
                </div>
            )}
        </div>
    );
};

export default FlightOfferGroup;
